// Role definitions
export enum UserRole {
  ADMIN = 'admin',
  INSPECTOR = 'inspector',
}

// Permission definitions
export enum Permission {
  // Dashboard
  VIEW_DASHBOARD = 'view_dashboard',

  // Inspections
  VIEW_INSPECTIONS = 'view_inspections',
  CREATE_INSPECTION = 'create_inspection',
  EDIT_INSPECTION = 'edit_inspection',
  DELETE_INSPECTION = 'delete_inspection',
  VIEW_INSPECTION_BOARD = 'view_inspection_board',

  // Vehicles
  VIEW_VEHICLES = 'view_vehicles',
  CREATE_VEHICLE = 'create_vehicle',
  EDIT_VEHICLE = 'edit_vehicle',
  DELETE_VEHICLE = 'delete_vehicle',

  // Users (Admin only)
  VIEW_USERS = 'view_users',
  CREATE_USER = 'create_user',
  EDIT_USER = 'edit_user',
  DELETE_USER = 'delete_user',

  // Settings (Admin only)
  MANAGE_IP_ACCESS = 'manage_ip_access',
  MANAGE_SETTINGS = 'manage_settings',

  // Notifications
  VIEW_NOTIFICATIONS = 'view_notifications',
}

// Role to permissions mapping
export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  [UserRole.ADMIN]: [
    // All permissions for admin
    Permission.VIEW_DASHBOARD,
    Permission.VIEW_INSPECTIONS,
    Permission.CREATE_INSPECTION,
    Permission.EDIT_INSPECTION,
    Permission.DELETE_INSPECTION,
    Permission.VIEW_INSPECTION_BOARD,
    Permission.VIEW_VEHICLES,
    Permission.CREATE_VEHICLE,
    Permission.EDIT_VEHICLE,
    Permission.DELETE_VEHICLE,
    Permission.VIEW_USERS,
    Permission.CREATE_USER,
    Permission.EDIT_USER,
    Permission.DELETE_USER,
    Permission.MANAGE_IP_ACCESS,
    Permission.MANAGE_SETTINGS,
    Permission.VIEW_NOTIFICATIONS,
  ],
  [UserRole.INSPECTOR]: [
    // Limited permissions for inspector
    Permission.VIEW_DASHBOARD,
    Permission.VIEW_INSPECTIONS,
    Permission.CREATE_INSPECTION,
    Permission.EDIT_INSPECTION,
    Permission.VIEW_INSPECTION_BOARD,
    Permission.VIEW_VEHICLES,
    Permission.VIEW_NOTIFICATIONS,
  ],
};

// Helper function to check if user has permission
export const hasPermission = (userRole: string | undefined, permission: Permission): boolean => {
  if (!userRole) return false;

  // Map is_admin flag to role
  const role = userRole === 'admin' || userRole === UserRole.ADMIN
    ? UserRole.ADMIN
    : UserRole.INSPECTOR;

  return ROLE_PERMISSIONS[role]?.includes(permission) || false;
};

// Helper function to check if user has any of the permissions
export const hasAnyPermission = (userRole: string | undefined, permissions: Permission[]): boolean => {
  return permissions.some(permission => hasPermission(userRole, permission));
};

// Helper function to get all permissions for a role
export const getRolePermissions = (userRole: string | undefined): Permission[] => {
  if (!userRole) return [];

  const role = userRole === 'admin' || userRole === UserRole.ADMIN
    ? UserRole.ADMIN
    : UserRole.INSPECTOR;

  return ROLE_PERMISSIONS[role] || [];
};
